import type { MouseEvent } from "react";

/**
 * The card's own controls: the symbol link and the acknowledge button.
 *
 * A row-wide click handler over a row full of controls swallows all of them:
 * without this guard, "Ack" also opened the modal and the symbol link both
 * navigated and opened the modal at once.
 */
const CONTROL_SELECTOR = "a, button, input, select, textarea, [role=button], [role=link]";

/** Whether this click belongs to the row rather than to a control inside it. */
export function isRowClick(event: MouseEvent<HTMLElement>): boolean {
  const target = event.target;
  if (!(target instanceof Element)) return true;
  return target.closest(CONTROL_SELECTOR) === null;
}

/**
 * Whether the browser already has its own meaning for this click.
 *
 * Modified and non-primary clicks go through untouched, which is what keeps
 * cmd-click and middle-click opening the signal in a new tab (decision D5).
 */
export function isPlainClick(event: MouseEvent<HTMLElement>): boolean {
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
  return event.button === 0;
}
